
export const apiUrl = "https://cms.sharepass.com/";
export const apiBaseUrl = `${apiUrl}wp-json/wp/v2/`;
export const defaultMetaTitle = 'SharePass | Don\'t risk it, SharePass it!';
export const defaultMetaDescription = 'Share passwords or any private data using a secure link without leaving a digital footprint, easy and smooth.';
export const defaultOgImg = "https://sharepass.com/assets/logo-og.png";
